import { useEffect } from "react";

/**
 * Scrolls smoothly to whatever element matches the current URL hash, once `ready` is true.
 *
 * `ready` exists because the target (e.g. the Messages card) only exists in the DOM once the
 * page's own data has loaded — scrolling on mount, before that, would find nothing. Runs once per
 * `ready`/hash change rather than watching the DOM, since every case page here loads its data once
 * and then only patches state in place (comments polling, etc.), not full remounts.
 */
export function useScrollToHash(ready) {
  useEffect(() => {
    if (!ready) return;
    const hash = window.location.hash;
    if (!hash) return;
    const el = document.querySelector(hash);
    el?.scrollIntoView({ behavior: "smooth", block: "start" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, window.location.hash]);
}
